import { useSelector } from "react-redux";

export const useLanguageTranslation = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const getText = (englishText, hindiText) =>
    languageType === "hi" ? hindiText : englishText;

  return { getText };
};
